import './src/fonts/fonts.css';
import './src/global.css';
import React from "react";
import { CursorProvider } from "./src/shared/ui/CursorContext";
import CustomCursor from "./src/shared/ui/CustomCursor";

export const wrapRootElement = ({ element }) => (
  <CursorProvider>
    {element}
    <CustomCursor />
  </CursorProvider>
);
